/**
 * 테마 관리 유틸리티
 * - 다크 모드와 라이트 모드 전환
 * - 사용자 설정 저장 및 로드
 */

// 테마 상수
const THEME_KEY = 'sns-theme-preference';
const THEME_DARK = 'dark';
const THEME_LIGHT = 'light';

/**
 * 현재 테마 모드 반환
 * @returns {string} 현재 테마 모드 ('dark' 또는 'light')
 */
export const getCurrentTheme = () => {
  // 로컬 스토리지에서 저장된 테마 확인
  const savedTheme = localStorage.getItem(THEME_KEY);
  
  if (savedTheme) {
    return savedTheme;
  }
  
  // 시스템 설정 확인
  if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return THEME_DARK;
  }
  
  // 기본값은 라이트 모드
  return THEME_LIGHT;
};

/**
 * 테마 적용 함수
 * @param {string} theme - 적용할 테마 ('dark' 또는 'light')
 */
const applyTheme = (theme) => {
  document.documentElement.setAttribute('data-theme', theme);
  
  // 테마 버튼 아이콘 업데이트
  const themeToggleBtn = document.getElementById('theme-toggle');
  if (themeToggleBtn) {
    const icon = themeToggleBtn.querySelector('i');
    if (icon) {
      icon.className = theme === THEME_DARK ? 'bi bi-sun' : 'bi bi-moon';
    }
  }
  
  // 메타 태그 업데이트 (PWA 테마 색상)
  const metaThemeColor = document.querySelector('meta[name="theme-color"]');
  if (metaThemeColor) {
    metaThemeColor.setAttribute('content', theme === THEME_DARK ? '#18191A' : '#4267B2');
  }
  
  // 로컬 스토리지에 저장
  localStorage.setItem(THEME_KEY, theme);
};

/**
 * 테마 초기화 함수
 */
export const initTheme = () => {
  const theme = getCurrentTheme();
  applyTheme(theme);
  
  // 시스템 테마 변경 감지
  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', e => {
      if (!localStorage.getItem(THEME_KEY)) {
        // 사용자가 직접 테마를 설정하지 않은 경우에만 시스템 설정 따르기
        applyTheme(e.matches ? THEME_DARK : THEME_LIGHT);
      }
    });
  }
};

/**
 * 테마 전환 함수
 */
export const toggleTheme = () => {
  const currentTheme = getCurrentTheme();
  const newTheme = currentTheme === THEME_LIGHT ? THEME_DARK : THEME_LIGHT;
  
  applyTheme(newTheme);
  
  return newTheme;
}; 